import { render, staticRenderFns } from "./vipCoupon.vue?vue&type=template&id=d42e184e&scoped=true&"
import script from "./vipCoupon.vue?vue&type=script&lang=js&"
export * from "./vipCoupon.vue?vue&type=script&lang=js&"
import style0 from "./vipCoupon.vue?vue&type=style&index=0&id=d42e184e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42e184e",
  null
  
)

export default component.exports